import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import format from "date-fns/format";

import FormButton from '../FormButton';
import DataValue from '../../components/DataValue';

import { goToStep, FORM_STEP1, FORM_STEP2, FORM_STEP3, FORM_STEP4 } from '../Form/actionCreator';
import { updatedFetch } from '../../utils/fetch/actionCreators';
import { fetchStarted, fetchCompleted } from '../App/actionCreator';
import { manageResponseAlerts } from '../Alert/actionCreator';

import { getFetchAuth } from '../../components/HeaderLogin/selectors';
import { getIsFetching, getHasProfile, getEmail } from '../App/selectors';
import { getConvention, getProducts } from '../Form/selectors';

import { getPrivacyInfo, payment_type_options, personTypeOptions, isPhysicalPerson, contractTypes } from '../../utils/commonFormsConfig';
import { baseURL } from '../../utils/fetch/axios';
import { getContractTypes } from '../Step1/index';
import formatISO from 'date-fns/formatISO';


class Step5 extends Component {
	formatStepsData = () => {
		const { valuesStep1, valuesStep2, valuesStep3, valuesStep4, hasProfile, email } = this.props;

		const step1 = valuesStep1 ? valuesStep1.toJS() : {};
		const step2 = valuesStep2 ? valuesStep2.toJS() : {};
		const step3 = valuesStep3 ? valuesStep3.toJS() : {};
		const step4 = valuesStep4 ? valuesStep4.toJS() : {};

		step2.dataDiNascita = formatISO(new Date(step2.dataDiNascita));
		step2.persona = isPhysicalPerson(step2.personType);
		step3.country = step3.nazione.value;
		delete step2.personType;

		step3.indirizzo = step3.address;
		step3.nazione = step3.nazione.value;

		if (step2.phone1Prefix) {
			step2.phone1 = step2.phone1?.slice(step2.phone1Prefix.length - 1);
		}
		if (step2.mobilePhone1Prefix) {
			step2.mobilePhone1 = step2.mobilePhone1?.slice(step2.mobilePhone1Prefix.length - 1);
		}

		delete step3.address;

		step4.bankCountryCode = step4.bankCountryCode.value;
		step4.authComunicazioniPromo = step4.authComunicazioniPromo === 'yes' ? true : false;
		step4.authProfilazioneUtente = step4.authProfilazioneUtente === 'yes' ? true : false;
		step4.authComunicazioneDati = step4.authComunicazioneDati === 'yes' ? true : false;

		if (step1.tipoContratto === contractTypes.flat) {
			if (step4.paymentType === '1') {
				step4.personaDeb = isPhysicalPerson(step4.personType);
				if (step4.personaDeb) {
					step4.firstNameDeb = step4.firstName;
					step4.lastNameDeb = step4.lastName;
				} else {
					step4.ragioneSocialeDeb = step4.ragioneSociale;
				}
				step4.indirizzoDeb = step4.address;
				step4.civicoDeb = step4.numeroCivico;
				step4.capDeb = step4.cap;
				step4.cittaDeb = step4.citta;
				step4.provinciaDeb = step4.provincia;
				step4.nazioneDeb = step4?.nazione?.value || "";
				delete step4.personType;
				delete step4.firstName;
				delete step4.lastName;
				delete step4.ragioneSociale;
				delete step4.numeroCivico;
				delete step4.citta;
				delete step4.provincia;
				delete step4.cap;
				delete step4.address;
				delete step4.nazione;
			}
		}

		return {
			origin: 'WEB',
			...step1,
			...step2,
			...step3,
			...step4,
			copySotData: true,
			hasProfile,
			email
		};
	};

	activateService = () => {
		const { updatedFetch, fetchAuth, valuesStep1, manageResponseAlerts, history, t } = this.props;

		const step1 = valuesStep1 ? valuesStep1.toJS() : {};
		this.setState({ saving: true });
		updatedFetch('POST', baseURL + '/UserData/contract', this.formatStepsData(), [fetchStarted], [fetchCompleted], [fetchCompleted], fetchAuth).then(() => {
			history.push('/contract-confirm?type=' + step1.tipoContratto, { type: step1.tipoContratto });
		})
			.catch(() => {
				manageResponseAlerts(false, false, t);
			});
	};

	renderPrivacyAuthorizations = (values) => {
		const { t } = this.props;

		const info = getPrivacyInfo(t);

		return <div className='d-flex flex-column gap-4 mb-4'>
			<div className='form-group no-label col-md-12'>
				<div>{info.authComunicazioniPromo}</div>
				<span className='font-italic'>{values.authComunicazioniPromo === "yes" ? t('form.step5.agree') : t('form.step5.notAgree')}</span>
			</div>
			<div className='form-group no-label col-md-12'>
				<div>{info.authProfilazioneUtente}</div>
				<span className='font-italic'>{values.authProfilazioneUtente === "yes" ? t('form.step5.agree') : t('form.step5.notAgree')}</span>
			</div>
			<div className='form-group no-label col-md-12'>
				<div>{info.authComunicazioneDati}</div>
				<span className='font-italic'>{values.authComunicazioneDati === "yes" ? t('form.step5.agree') : t('form.step5.notAgree')}</span>
			</div>
		</div>;
	};

	getStep1Data = () => {
		const { convention, products, valuesStep1, goToStep, t } = this.props;

		const step1 = valuesStep1 ? valuesStep1.toJS() : {};
		const currentOffer = getContractTypes(t).filter(o => {
			return o.value === step1.tipoContratto;
		})[0]?.label || '';
		const currentProduct = products.filter(p => {
			return p.product_code === step1.productCode;
		})[0]?.product_name || '';

		return <Fragment>
			<div className='row summary'>
				<div className='form-group col-md-12'>
					<h1 className='d-md-inline-block'>{t('form.step5.title_1')}</h1>
					<span className='modify-link' onClick={() => goToStep(1)}>{t('form.step5.link')}</span>
				</div>
			</div>
			<div className='row summary'>
				<div className='form-group no-label col-md-6'>
					<label>{t('form.step5.offer')}</label>
					<DataValue value={currentOffer}></DataValue>
				</div>
				<div className='form-group no-label col-md-6'>
					<label>{t('form.step5.service')}</label>
					<DataValue value={currentProduct}></DataValue>
				</div>
				{convention.validity && <div className='form-group no-label col-md-6'>
					<label>{t('form.step5.convention')}</label>
					<DataValue value={convention.name}></DataValue>
				</div>}
			</div>
		</Fragment>;
	};

	getStep2Data = () => {
		const { valuesStep2, goToStep, hasProfile, t } = this.props;

		const values = valuesStep2 ? valuesStep2.toJS() : {};
		const personType = personTypeOptions.filter(t => t.value === values.personType)[0].label;
		const dateOfBirth = format(new Date(values.dataDiNascita), "dd/MM/yyyy");

		return <Fragment>
			<div className='row summary'>
				<div className='form-group col-md-12'>
					<h1 className='d-md-inline-block'>{t('form.step5.title_2')}</h1>
					{!hasProfile ? <span className='modify-link' onClick={() => goToStep(2)}>{t('form.step5.link')}</span> : ''}
				</div>
			</div>
			<div className='row summary'>
				<div className='form-group col-md-6'>
					<label>{t('form.step5.accountType')}</label>
					<DataValue value={personType}></DataValue>
				</div>
			</div>
			<div className='row summary'>
				<div className='form-group col-md-6'>
					<label>{t('form.step5.name')}</label>
					<DataValue value={values.firstName}></DataValue>
				</div>
				<div className='form-group col-md-6'>
					<label>{t('form.step5.surname')}</label>
					<DataValue value={values.lastName}></DataValue>
				</div>
				{
					values.phone1 ? <div className='form-group col-md-6'>
						<label>{t('form.step5.phone')}</label>
						<DataValue value={'+' + values.phone1}></DataValue>
					</div> : ''
				}
				<div className='form-group col-md-6'>
					<label>{t('form.step5.mobilePhone')}</label>
					<DataValue value={'+' + values.mobilePhone1}></DataValue>
				</div>
				<div className='form-group col-md-6'>
					<label>{t('form.step5.dateOfBirth')}</label>
					<DataValue value={dateOfBirth} />
				</div>
			</div>
			{
				values.personType === '2' && <Fragment>
					<div className='row'>
						<div className='col'>
							<h4 className='mb-2'>{t('form.step5.subtitle_1')}</h4>
						</div>
					</div>
					<div className='row summary'>
						<div className='form-group col-md-6'>
							<label>{t('form.step5.legalName')}</label>
							<DataValue value={values.rappresentanteLegaleNome}></DataValue>
						</div>
						<div className='form-group col-md-6'>
							<label>{t('form.step5.legalSurname')}</label>
							<DataValue value={values.rappresentanteLegaleCognome}></DataValue>
						</div>
					</div>
					<div className='row'>
						<div className='col'>
							<h4 className='mb-2'>{t('form.step5.subtitle_2')}</h4>
						</div>
					</div>
					<div className='row summary'>
						<div className='form-group col-md-6'>
							<label>{t('form.step5.businessName')}</label>
							<DataValue value={values.ragioneSociale}></DataValue>
						</div>
					</div>
					<div className='row summary'>
						<div className='form-group col-md-6'>
							<label>{t('form.step5.pIva')}</label>
							<DataValue value={values.partitaIva}></DataValue>
						</div>
						<div className='form-group col-md-6'>
							<label>{t('form.step5.companyCf')}</label>
							<DataValue value={values.codiceFiscaleAzienda}></DataValue>
						</div>
						{
							values.pec ? <div className='form-group col-md-6'>
								<label>{t('form.step5.pec')}</label>
								<DataValue value={values.pec}></DataValue>
							</div> : ''
						}
						{
							values.codiceSDI ? <div className='form-group col-md-6'>
								<label>{t('form.step5.sdi')}</label>
								<DataValue value={'' + values.codiceSDI}></DataValue>
							</div> : ''
						}
					</div>
				</Fragment>
			}
		</Fragment>;
	};

	getStep3Data = () => {
		const { valuesStep3, goToStep, t } = this.props;

		const values = valuesStep3 ? valuesStep3.toJS() : {};
		const nation = values.nazione ? values.nazione.label : '';
		const fullAddress = `${values.address} ${values.numeroCivico}, ${values.frazione ? `${values.frazione}, ` : ''}${values.citta}, ${values.provincia} ${values.cap}`;
		const isIta = values.nazione ? values.nazione.value === 'IT' : false;

		return <Fragment>
			<div className='row summary'>
				<div className='form-group col-md-12'>
					<h1 className='d-md-inline-block'>{t('form.step5.title_3')}</h1>
					<span className='modify-link' onClick={() => goToStep(3)}>{t('form.step5.link')}</span>
				</div>
			</div>
			<div>
				<div className='row summary'>
					<div className='form-group col-md-6'>
						<label>{t('form.step5.address')}</label>
						<DataValue value={fullAddress}></DataValue>
					</div>
					<div className='form-group col-md-6'>
						<label>{t('form.step5.nazione')}</label>
						<DataValue value={nation}></DataValue>
					</div>
					{
						isIta && <div className='form-group col-md-6'>
							<label>{t('form.step5.cf')}</label>
							<DataValue value={values.codiceFiscale}></DataValue>
						</div>
					}
					<div className='form-group col-md-6'>
						<label>{t('form.step5.plate')}</label>
						<DataValue value={values.targaVeicolo}></DataValue>
					</div>
					{
						values.modelloVeicolo ? <div className='form-group col-md-6'>
							<label>{t('form.step5.model')}</label>
							<DataValue value={values.modelloVeicolo}></DataValue>
						</div> : ''
					}
				</div>
			</div>
		</Fragment>;
	};

	getStep4Data = () => {
		const { valuesStep1, valuesStep4, goToStep, t } = this.props;

		const prevStep1Values = valuesStep1 ? valuesStep1.toJS() : {};
		const values = valuesStep4 ? valuesStep4.toJS() : {};
		const paymentType = prevStep1Values.tipoContratto === contractTypes.flat ? payment_type_options.filter(p => {
			return (p.value === values.paymentType);
		})[0].label : 'Carta di credito';

		return <Fragment>
			<div className='row summary'>
				<div className='form-group col-md-12'>
					<h1 className='d-md-inline-block'>{t('form.step5.title_4')}</h1>
					<span className='modify-link' onClick={() => goToStep(4)}>{t('form.step5.link')}</span>
				</div>
			</div>
			<div className='row summary'>
				<div className='form-group col-md-6'>
					<label>{t('form.step5.paymentMode')}</label>
					<DataValue value={paymentType}></DataValue>
				</div>
			</div>
			<div className='row summary'>
				<div className='form-group col-md-12'>
					<h4 className='text-uppercase'>{t('form.step5.subtitle_3')}</h4>
				</div>
			</div>
			{this.renderPrivacyAuthorizations(values)}
		</Fragment>;
	};

	getSummary = () => {
		const { isFetching, t } = this.props;

		return (
			<Fragment>
				<div className='row'>
					<div className='col-sm-6 offset-sm-3 d-grid gap-2'>
						<button className='btn btn-block btn-success my-2 text-uppercase' disabled={isFetching} onClick={this.activateService}>{t('form.step5.activate')}</button>
					</div>
				</div>
				{this.getStep1Data()}
				{this.getStep2Data()}
				{this.getStep3Data()}
				{this.getStep4Data()}
			</Fragment>
		);
	};

	render() {
		return <div className='px-lg-4'>
			{this.getSummary()}
			<FormButton {...this.props} onSubmit={this.activateService} lastStep={true}></FormButton>
		</div>;
	}
}

const mapStateToProps = (state) => {
	return {
		valuesStep1: getFormValues(FORM_STEP1)(state),
		valuesStep2: getFormValues(FORM_STEP2)(state),
		valuesStep3: getFormValues(FORM_STEP3)(state),
		valuesStep4: getFormValues(FORM_STEP4)(state),
		convention: getConvention(state).toJS(),
		products: getProducts(state).toJS(),
		fetchAuth: getFetchAuth(state),
		isFetching: getIsFetching(state),
		hasProfile: getHasProfile(state),
		email: getEmail(state)
	};
};

const mapDispatchToProps = {
	goToStep,
	updatedFetch,
	manageResponseAlerts
};

Step5.propTypes = {
	valuesStep1: PropTypes.object,
	valuesStep2: PropTypes.object,
	valuesStep3: PropTypes.object,
	valuesStep4: PropTypes.object,

	goToStep: PropTypes.func,
	updatedFetch: PropTypes.func,
	manageResponseAlerts: PropTypes.func,

	convention: PropTypes.object,
	products: PropTypes.array,
	fetchAuth: PropTypes.object,
	isFetching: PropTypes.bool,
	hasProfile: PropTypes.bool,
	email: PropTypes.string,

	history: PropTypes.object,
	t: PropTypes.func
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Step5));
